export default "__VITE_ASSET__Bcxsj2UQ__"